require('./orderHandling.less');

class UserHandlingController {
    order;
    private modalInstance;

    constructor() {
    }

    action(action) {
        this.modalInstance.hide(action);
    }

    closeModal() {
        this.modalInstance.cancel();
    }
}

class OrderHandlingOptions implements ng.IComponentOptions {
    controller = 'rkcOrderHandlingController';
    controllerAs = "c";
    template: any = require('./orderHandling.html');
    bindings: any = {
        order: '=',
        modalInstance: '='
    };
}

rkcApp.controller("rkcOrderHandlingController", [
    function () {
        return new UserHandlingController();
    }])
    .component("rkcOrderHandling", new OrderHandlingOptions())
;


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/orders/orderHandling/orderHandling.ts
 **/